import { render } from "./ObservationCard.vue?vue&type=template&id=401eb1ba&scoped=true"
import script from "./ObservationCard.vue?vue&type=script&lang=js"
export * from "./ObservationCard.vue?vue&type=script&lang=js"

import "./ObservationCard.vue?vue&type=style&index=0&id=401eb1ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401eb1ba"]])

export default __exports__